module.exports = {
          srcSet: "/_next/static/images/img-informatique@2x-200-ddbd49b16882816699df6f52e572f8f4.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-informatique@2x-200-ddbd49b16882816699df6f52e572f8f4.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-informatique@2x-200-ddbd49b16882816699df6f52e572f8f4.jpg",
          toString:function(){return "/_next/static/images/img-informatique@2x-200-ddbd49b16882816699df6f52e572f8f4.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }